/**
 * Types for CRM embed PostMessage communication
 * Must match CRM's utils/embedMessaging.js constants
 */

// Message types - MUST match CRM's CRM_MESSAGES
export const CRM_MESSAGES = {
  // Incoming from CRM (CRM -> React)
  READY: "CRM_READY",
  ROUTE_CHANGE: "CRM_ROUTE_CHANGE",
  ERROR: "CRM_ERROR",
  STATE: "CRM_STATE",
  NAVIGATE_PARENT: "CRM_NAVIGATE_PARENT", // CRM requests parent to navigate

  // Outgoing to CRM (React -> CRM)
  NAVIGATE: "CRM_NAVIGATE",
  GET_STATE: "CRM_GET_STATE",
} as const;

export interface CrmEmbedRef {
  /** Navigate to a path within CRM */
  navigate: (path: string) => void;
  /** Get current CRM state */
  getState: () => Promise<CrmState>;
  /** Check if CRM is ready */
  readonly isReady: boolean;
}

export interface CrmState {
  path: string;
  title: string;
}

export interface CrmEmbedProps {
  /** Initial path within CRM (e.g., '/leads', '/deals/DEAL-001') */
  initialPath?: string;
  /** Additional className for container */
  className?: string;
  /** Called when CRM is ready */
  onReady?: () => void;
  /** Called when route changes within CRM */
  onRouteChange?: (path: string, title: string) => void;
  /** Called on error */
  onError?: (error: string) => void;
  /** Called when CRM requests parent navigation (e.g., back button) */
  onNavigateParent?: (action: string) => void;
}

export interface CrmMessage {
  type: string;
  payload?: unknown;
  requestId?: string;
  timestamp?: number;
}

// Payload types
export interface CrmReadyPayload {
  version: string;
}

export interface CrmRouteChangePayload {
  path: string;
  title: string;
}

// GOTCHA G13: CRM sends { message }, matches crmEmbedMessenger.notifyError
export interface CrmErrorPayload {
  message: string;
  code?: string;
}

export interface CrmStatePayload {
  path: string;
  title: string;
}

export interface CrmNavigatePayload {
  path: string;
}

export interface CrmNavigateParentPayload {
  action: "back" | "home" | string; // 'back', 'home', or a path
}
